module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0025.jpg?v=96280c4d";